// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chevron-up-double"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16.5 10.5L12 6L7.5 10.5M16.5 17L12 12.5L7.5 17","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChevronUpDoubleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chevron-up-double',
    ref,
    icon: element,
  },
));

ChevronUpDoubleIcon.displayName = 'ChevronUpDoubleIcon';

export default ChevronUpDoubleIcon;
